import React from "react";
import styled from "@emotion/styled";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import theme from "@/theme";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .${tooltipClasses.arrow} {
    color: hsl(var(--color-white));
    font-size: 32px;

    ::before {
      border: 1px solid hsl(var(--color-primary-200));
    }
  }
  & .${tooltipClasses.tooltip} {
    background: hsl(var(--color-white));
    border: 1px solid hsl(var(--color-primary-200));
    max-width: 350px;
    padding: ${theme.spacing(1)};
    color: hsl(var(--color-gray-700));
    font-weight: 400;
    font-size: 12px;
    line-height: 125%;

    > * {
      margin: 0;
    }
  }
`;

export const DroppsTooltip = (props: TooltipProps) => {
  return (
    <StyledTooltip
      arrow
      enterTouchDelay={0}
      tabIndex={0}
      describeChild
      componentsProps={{ tooltip: { className: "shadow" } }}
      {...props}
    >
      {props.children}
    </StyledTooltip>
  );
};
